/*
 * Identidade anônima do trial v2 — UUID v4 persistido em localStorage.
 *
 * O backend (TRIAL_V2_API.md) exige UUID v4 estrito no header X-Anon-Id:
 * formatos não-v4 retornam 400 invalid_anon_id. Por isso validamos o valor
 * armazenado com regex antes de reutilizar — valor corrompido é regenerado.
 */

const ANON_ID_KEY = 'drpera-anon-id';

/** Regex estrita de UUID v4 (versão = 4, variant = 8/9/a/b) */
const UUID_V4_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/** Gera UUID v4 — crypto.randomUUID quando disponível, fallback manual */
function generateUuidV4(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback (mesmo pattern do generateSessionId em useChat.ts)
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}

/**
 * Retorna o anonId persistido, criando um novo se ausente ou inválido.
 * localStorage indisponível → retorna UUID efêmero (funciona na sessão).
 */
export function getOrCreateAnonId(): string {
  try {
    const atual = localStorage.getItem(ANON_ID_KEY);
    if (atual && UUID_V4_REGEX.test(atual)) return atual;
  } catch {
    /* localStorage bloqueado — segue pra geração efêmera */
  }
  const novo = generateUuidV4();
  try {
    localStorage.setItem(ANON_ID_KEY, novo);
  } catch {
    /* efêmero — aceitável */
  }
  return novo;
}

/**
 * Regenera o anonId (safety net pro 400 invalid_anon_id do backend).
 * Retorna o novo UUID.
 */
export function resetAnonId(): string {
  try {
    localStorage.removeItem(ANON_ID_KEY);
  } catch {
    /* ignore */
  }
  return getOrCreateAnonId();
}
